import PropTypes from 'prop-types';
import { getPhoneNumberDisplay } from '@zg-rentals/formatters';
import styled from 'styled-components';
import { TextButton } from '@zillow/constellation';

const StyledTextButton = styled(TextButton)`
  text-align: start;
`;

export default function PhoneNumber({ phone }) {
  const href = `tel:${phone}`;
  const displayText = getPhoneNumberDisplay(phone) ?? phone;

  return (
    <StyledTextButton as="a" href={href}>
      {displayText}
    </StyledTextButton>
  );
}

PhoneNumber.propTypes = {
  phone: PropTypes.string.isRequired,
};
